// src/data.js
// Este archivo contiene todos los productos del catálogo.
// ¡Recuerda reemplazar los nombres de las imágenes con los nombres reales de tus fotos!

export const catalogoData = [
  // --- PALOS DE QUESO GRANDES ---
  {
    id: 1,
    categoria: "Palos de Queso GRANDES",
    nombre: "Palo de Queso Tradicional",
    peso: "80g",
    tamaño: "14 cm aprox",
    descripcion: "El clásico y delicioso palo de queso que todos aman.",
    precios: [
      { unidades: 20, valor: 29500 },
      { unidades: 10, valor: 15000 },
    ],
    imagen: "/images/foto-palitos.jpg",
  },
  {
    id: 2,
    categoria: "Palos de Queso GRANDES",
    nombre: "Palo de Queso con Bocadillo",
    peso: "80g",
    tamaño: "14 cm aprox",
    descripcion: "La combinación perfecta de queso salado y dulce de bocadillo.",
    precios: [
      { unidades: 20, valor: 30500 },
      { unidades: 10, valor: 17000 },
    ],
    imagen: "/images/palito-bocadillo.jpg",
  },
  {
    id: 3,
    categoria: "Palos de Queso GRANDES",
    nombre: "Palo de Queso con Arequipe",
    peso: "80g",
    tamaño: "14 cm aprox",
    descripcion: "Una delicia cremosa para los amantes del arequipe.",
    precios: [
      { unidades: 20, valor: 30500 },
      { unidades: 10, valor: 17000 },
    ],
    imagen: "/images/palo-mini-arequipe.jpg",
  },

  // --- PALOS DE QUESO PEQUEÑOS ---
  {
    id: 4,
    categoria: "Palos de Queso PEQUEÑOS",
    nombre: "Palito de queso pequeño con queso",
    peso: "30g",
    tamaño: "7 cm aprox",
    descripcion: "Paquete x20 unidades, ideal para eventos y reuniones.",
    precios: [{ unidades: 20, valor: 20000 }],
    imagen: "/images/palito.jpg",
  },
  {
    id: 5,
    categoria: "Palos de Queso PEQUEÑOS",
    nombre: "Palito de queso pequeño con bocadillo",
    peso: "30g",
    tamaño: "7 cm aprox",
    descripcion: "Paquete x20 unidades, el toque dulce para tus pasabocas.",
    precios: [{ unidades: 20, valor: 21000 }],
    imagen: "/images/palo-mini-bocadillo.jpeg",
  },
  {
    id: 6,
    categoria: "Palos de Queso PEQUEÑOS",
    nombre: "Palito de queso pequeño con arequipe",
    peso: "30g",
    tamaño: "7 cm aprox",
    descripcion: "Paquete x20 unidades, cremosidad en tamaño coctelero.",
    precios: [{ unidades: 20, valor: 21000 }],
    imagen: "/images/palo-mini-arequipe.jpg",
  },
 

  // --- PANZEROTTIS ---
  {
    id: 7,
    categoria: "Panzerottis",
    nombre: "Panzerottis",
    peso: "140g aprox.",
    descripcion: "Paquete x5 unidades. Disponibles en los siguientes sabores: Ranchero, Tociranchero, Hawaiano, Tocimaicitos, Arequipe y Pollo Tocineta.",
    precios: [
      { presentacion: "Ranchero", valor: 11000 },
      { presentacion: "Tociranchero", valor: 11000 },
      { presentacion: "Hawaiano", valor: 11000 },
      { presentacion: "Tocimaicitos", valor: 11000 },
      { presentacion: "Arequipe", valor: 11000 },
      { presentacion: "Pollo Tocineta", valor: 12000 }
    ],
    imagen: "/images/panzerotti.jpg",
  },

  // --- EMPANADAS ---
  {
    id: 9,
    categoria: "Empanadas",
    nombre: "Empanaditas Tipo Iglesia",
    descripcion: "La receta tradicional tipo iglesia con relleno de solo papa y guiso.",
    peso: "25g",
    precios: [
      { unidades: 50, valor: 26000 },
      { unidades: 25, valor: 14000 },
    ],
    imagen: "/images/foto-empanadas.jpg",
  },

    {
    id: 10,
    categoria: "Empanadas",
    nombre: "Empanadas",
    descripcion: "La receta tradicional x15 unidades con relleno de solo papa y guiso.",
    peso: "100g",
    precios: [
      { unidades: 15, valor: 33500 },
    ],
    imagen: "/images/empanada.jpeg",
  },

  // --- PASTELES DE POLLO ---
  {
    id: 11,
    categoria: "Pasteles",
    nombre: "Pastelitos de Pollo",
    peso: "40g",
    descripcion: "Exquisitos pastelitos cocteleros rellenos de papa, guiso y pollo.",
    precios: [
      { unidades: 40, valor: 50000 },
      { unidades: 20, valor: 26000 },
    ],
    imagen: "/images/foto-pastel.jpg",
  },

    {
    id: 12,
    categoria: "Pasteles",
    nombre: "Pasteles de Pollo",
    peso: "150g",
    descripcion: "Exquisitos pasteles x10 unidades rellenos de papa, guiso y pollo.",
    precios: [
      { unidades: 10, valor: 47000 },
    ],
    imagen: "/images/pasteles.jpeg",
  },
];